export enum BillStatus {
    Created,
    Transferred,
    Cancelled
}